module.exports = __webpack_public_path__ + "img/BG_blue.00ca6f71.png";